import React from "react";
import { APP_VERSION } from "../productEducation/config/appRelease";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[CrewPilot] Unhandled render error", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="app nx-app">
        <div
          style={{
            maxWidth: "480px",
            margin: "48px auto",
            padding: "24px",
            color: "#e8ecf4",
          }}
        >
          <h1 style={{ fontSize: "22px", marginBottom: "12px" }}>
            Something went wrong
          </h1>
          <p style={{ opacity: 0.85, lineHeight: 1.5, marginBottom: "20px" }}>
            CrewPilot encountered an unexpected error. Your data is saved locally
            where applicable. Try reloading the page or return to the home
            screen.
          </p>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <pre
              style={{
                fontSize: "12px",
                overflow: "auto",
                padding: "12px",
                background: "rgba(255,255,255,0.06)",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              {this.state.error.message}
            </pre>
          )}
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <button type="button" className="nx-btn nx-btn-gold" onClick={this.handleReload}>
              Reload page
            </button>
            <button type="button" className="nx-btn" onClick={this.handleGoHome}>
              Return home
            </button>
          </div>
          <p style={{ marginTop: "24px", fontSize: "12px", opacity: 0.5 }}>
            CrewPilot v{APP_VERSION}
          </p>
        </div>
      </div>
    );
  }
}
